import { postData, fetchData } from "./api";
export const applyJob = async (data) =>
  await postData(`/api/application`, data);

export const fetchRelatedCareers = async (data) =>
  await fetchData("/api/career", data, null);
